import { render } from "./Layout.vue?vue&type=template&id=50d391b2"
const script = {}

import exportComponent from "/codebuild/output/src398903933/src/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__